<template>
  <img v-if="file" :src="src" @error="changeUrl"/>
</template>

<script>
import settings from "@/settings";

export default {
name: "ImageWrapper",
  props: ['file'],
  data() {
    return {
      prodImageSource: settings.PROD_IMAGE_API,
      src: `${settings.PROD_IMAGE_API}${this.file}`,
      current: 'PROD'
    }
  },
  methods: {
    changeUrl() {
      if(this.current === 'PROD') {
        this.src = `${settings.STAGE_IMAGE_API}${this.file}`
        this.current = 'STAGE'
      }
    }
  }
}
</script>

<style scoped>

</style>